export default __webpack_public_path__ + "static/media/earth.28543e3a.svg";